export enum AccountDeletionReason {
  FundedOtherInstitution = "FUNDED_OTHER_INSTITUTION",
  NestoDifficultToUse = "NESTO_DIFFICULT_TO_USE",
  NotEffective = "NOT_EFFECTIVE",
  WindowShopping = "WINDOW_SHOPPING",
  Other = "OTHER",
  NoReason = "NO_REASON",
}
